var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 101,
    viewBox: "0 0 154 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_961_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.969 49.5885C121.969 59.8018 124.78 72.5496 76.9844 68.0814C52.1402 68.0814 32 59.8018 32 49.5885C32 39.3751 34.8115 56.391 79.7959 32.0073C104.64 32.0073 121.969 31.0955 121.969 49.5885Z",
    fill: "url(#paint0_linear_961_2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_961_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.969 49.5885C121.969 59.8018 124.78 72.5496 76.9844 68.0814C52.1402 68.0814 32 59.8018 32 49.5885C32 39.3751 34.8115 56.391 79.7959 32.0073C104.64 32.0073 121.969 31.0955 121.969 49.5885Z",
    fill: "url(#paint1_linear_961_2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_961_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.969 49.5885C121.969 59.8018 124.78 72.5496 76.9844 68.0814C52.1402 68.0814 32 59.8018 32 49.5885C32 39.3751 34.8115 56.391 79.796 32.0073C104.64 32.0073 121.969 31.0955 121.969 49.5885Z",
    fill: "url(#paint2_linear_961_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_961_2",
    x: 0,
    y: 0,
    width: 154,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_961_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_961_2",
    x: 20,
    y: 20,
    width: 114,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_961_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_961_2",
    x: 28,
    y: 28,
    width: 98,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_961_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_961_2",
    x1: 113.534,
    y1: 32.0073,
    x2: 16.3682,
    y2: 59.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A71FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A65FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_961_2",
    x1: 113.534,
    y1: 32.0073,
    x2: 16.3682,
    y2: 59.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A71FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A65FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_961_2",
    x1: 113.534,
    y1: 32.0073,
    x2: 16.3682,
    y2: 59.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A71FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A65FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBlur);
export default __webpack_public_path__ + "static/media/buttonBlur.1e2a20d6f1d1608260256a30574ca82c.svg";
export { ForwardRef as ReactComponent };